"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJSAdded = void 0;
function isJSAdded(url) {
    return !!document.querySelector(`script[src="${url}"]`);
}
exports.isJSAdded = isJSAdded;
